<h3 mat-dialog-title>Zmiana prowizji</h3>
<mat-dialog-content>
	<p>
		Aktualna prowizja: <span class="fw-bold">{{ dialogData().currentCommissionValue | price }} PLN</span>
	</p>
	<mat-form-field appearance="outline" class="w-100">
		<mat-label>Nowa prowizja (PLN)</mat-label>
		<input type="number" [formControl]="newCommission" matInput />
		<mat-error *ngIf="newCommission.errors?.['required']">Pole jest wymagane</mat-error>
		<mat-error *ngIf="newCommission.errors?.['min']">
			Wartość prowizji nie może być mniejsza niż:
			<span class="fw-bold">{{ MIN_COMMISSION_VALUE | price }} PLN</span>
		</mat-error>
		<mat-error *ngIf="newCommission.errors?.['max']">
			Wartość prowizji nie może przekraczać wartości rezerwacji:
			<span class="fw-bold">{{ maxCommissionValue | price }} PLN</span>
		</mat-error>
	</mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-raised-button color="warn" (click)="close()">Odrzuć</button>
	<button mat-raised-button color="primary" (click)="save()">Zapisz</button>
</mat-dialog-actions>
